export default __webpack_public_path__ + "static/media/04PersonalDetails-1.aa0c51e7.png";